export const MATERIAL_ICON_FONT_SET = 'material-icons-outlined';
